const config = {
  api_base_url_stg: "https://gulglam-backend.promxa.com/api",
  api_base_url_live: "https://gulglam-backend.promxa.com/api",
  socket_url: "https://gulglam-backend.promxa.com:3888",
  whatsapp_api_url: "https://gulglam-backend.promxa.com:3888",
};
export default config;



